import React from "react";
import { FaGem, FaBuilding, FaCertificate } from "react-icons/fa"; // Importing from react-icons/fa
import "./WhyChooseUsSection.css";

const benefits = [
  {
    title: "Custom Cutting",
    description:
      "Precision cutting services for both natural and lab-grown diamonds, maximizing brilliance and value.",
    icon: <FaGem className="icon-large" />,
  },
  {
    title: "Wholesale",
    description:
      "Bulk diamond supply for jewelers and manufacturers with competitive pricing and consistent quality.",
    icon: <FaBuilding className="icon-large" />,
  },
  {
    title: "Certification",
    description:
      "Complete certification services through GIA and IGI for both natural and lab-grown diamonds.",
    icon: <FaCertificate className="icon-large" />,
  },
];

const WhyChooseUsSection = () => {
  return (
    <section className="why-choose-us1">
      <div className="container3">
        <h2 className="title1">Why Choose Us</h2>
        <p className="description1">
          Combining tradition with innovation to craft diamonds of unmatched
          brilliance and ethical integrity.
        </p>
        <div className="benefits-grid1">
          {benefits.map((benefit, index) => (
            <div
              className="benefit-card1 fade-up"
              key={index}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {benefit.icon}
              <h3 className="card-title1">{benefit.title}</h3>
              <p className="card-description1">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
